<template>
    <BreadCrumb PageTitle="Liste des clients" />
    <ListeClient/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../../components/Common/BreadCrumb.vue";
    import ListeClient from "../../../components/Ecommerce/Client/ListeClient.vue";

    export default defineComponent({
      name: "ListeClientPage",
      components: {
        BreadCrumb,
        ListeClient,
      },
    });
  </script>